import { lazy } from 'react';

export const LazyCompanyInvitationView = lazy(() =>
  import('../invitation/CompanyInvitations').then((module) => ({
    default: module.CompanyInvitationsView,
  })),
);
